'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dHelper$0024$0024anon$00244 from "./presto.-Login-Helper$$anon$4.js";
import * as $j_presto$002etypes$0024proto$0024$002dLogoff$002dResponse$0024 from "./presto.types$proto$-Logoff-Response$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginHelper$$anon$3() {
  this.b5H = null;
  this.b5z = null;
  this.b5A = false;
  this.b5I = null;
  this.b5J = false;
  this.b5M = null;
  this.b5F = null;
  this.b5G = false;
  this.b5B = null;
  this.b5C = false;
  this.b5D = null;
  this.b5E = false;
  this.b5K = false;
  this.b5L = false;
  this.b5H = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.b5M = "LogoffResponse";
}
export { $c_Lpresto_LoginHelper$$anon$3 as $c_Lpresto_LoginHelper$$anon$3 };
$p = $c_Lpresto_LoginHelper$$anon$3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginHelper$$anon$3;
/** @constructor */
function $h_Lpresto_LoginHelper$$anon$3() {
}
export { $h_Lpresto_LoginHelper$$anon$3 as $h_Lpresto_LoginHelper$$anon$3 };
$h_Lpresto_LoginHelper$$anon$3.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.b5H;
});
$p.M = (function() {
  if ((!this.b5A)) {
    this.b5z = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b5A = true;
  }
  return this.b5z;
});
$p.O = (function() {
  if ((!this.b5J)) {
    this.b5I = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.b5J = true;
  }
  return this.b5I;
});
$p.D = (function() {
  return this.b5M;
});
$p.t = (function() {
  if ((!this.b5G)) {
    this.b5F = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("restored", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.b5G = true;
  }
  return this.b5F;
});
$p.N = (function() {
  if ((!this.b5C)) {
    this.b5B = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aq, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.b5C = true;
  }
  return this.b5B;
});
$p.Q = (function() {
  if ((!this.b5E)) {
    this.b5D = new $j_presto$002e$002dLogin$002dHelper$0024$0024anon$00244.$c_Lpresto_LoginHelper$$anon$4();
    this.b5E = true;
  }
  return this.b5D;
});
$p.v = (function() {
  if ((!this.b5L)) {
    this.b5K = false;
    this.b5L = true;
  }
  return this.b5K;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee27) => ((p) => \u03b4scrutinee27.cHS(p)))($j_presto$002etypes$0024proto$0024$002dLogoff$002dResponse$0024.$m_Lpresto_types$proto$LogoffResponse$())));
});
var $d_Lpresto_LoginHelper$$anon$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginHelper$$anon$3, "presto.LoginHelper$$anon$3", ({
  M5: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_LoginHelper$$anon$3 as $d_Lpresto_LoginHelper$$anon$3 };
//# sourceMappingURL=presto.-Login-Helper$$anon$3.js.map
